export default "__VITE_ASSET__D$I6ici5__"